export default "__VITE_ASSET__CB7elIrG__"